import React from 'react';
import styled from 'styled-components';

import ContactPhone from 'static/images/landingMarketPlace/phoneBlur.webp';
import MainContactPhone from 'static/images/landingMarketPlace/phoneFirst.webp';
import LightningImage from 'static/images/landingMarketPlace/sparrow.webp';
import { DemoEmail } from 'shared/layouts/LandingLayout/components/DemoEmail';

export const ContactsSection = ({ refProp }) => {
    return (
        <ContactsWrapper ref={refProp}>
            <ContentContainer>
                <TitleBlock>
                    <Title>Контакты клиентов в одном месте</Title>
                </TitleBlock>

                <ContentBlock>
                    <PhoneContainer>
                        <PhoneImage
                            src={ContactPhone}
                            alt='Spodial contacts interface'
                        />
                        <MainPhoneImage
                            src={MainContactPhone}
                            alt='Spodial contacts interface'
                        />
                    </PhoneContainer>

                    <FeaturesContainer>
                        <FeaturesList>
                            <FeatureItem>
                                <LightningIcon>
                                    <img
                                        src={LightningImage}
                                        alt='LightningIcon'
                                    />
                                </LightningIcon>
                                <FeatureText>
                                    Фиксирует всех, кто зашел в магазин —
                                    запоминает контакты и время визита.
                                </FeatureText>
                            </FeatureItem>
                            <FeatureItem>
                                <LightningIcon>
                                    <img
                                        src={LightningImage}
                                        alt='LightningIcon'
                                    />
                                </LightningIcon>
                                <FeatureText>
                                    Покажет историю взаимодействий — какие
                                    товары смотрел, какие вопросы задавал.
                                </FeatureText>
                            </FeatureItem>
                            <FeatureItem>
                                <LightningIcon>
                                    <img
                                        src={LightningImage}
                                        alt='LightningIcon'
                                    />
                                </LightningIcon>
                                <FeatureText>
                                    Отправляет триггерные сообщения — например,
                                    если клиент добавил товар в корзину, но не
                                    купил.
                                </FeatureText>
                            </FeatureItem>
                            <FeatureItem>
                                <LightningIcon>
                                    <img
                                        src={LightningImage}
                                        alt='LightningIcon'
                                    />
                                </LightningIcon>
                                <FeatureText>
                                    Делает массовые рассылки — с персональными
                                    предложениями и акциями.
                                </FeatureText>
                            </FeatureItem>
                        </FeaturesList>
                        <DemoEmail
                            activator={
                                <RequestButton>Оставить заявку</RequestButton>
                            }
                        />
                    </FeaturesContainer>
                </ContentBlock>
            </ContentContainer>
        </ContactsWrapper>
    );
};

const ContactsWrapper = styled.section`
    padding: 48px 0;
    width: 100%;
    background: linear-gradient(134deg, #ff8fe5 0%, #7c3aed 100%);
    border-radius: 32px;
    margin: 40px 0;
`;

const ContentContainer = styled.div`
    max-width: 1160px;
    margin: 0 auto;
    padding: 0 20px;
`;

const TitleBlock = styled.div`
    margin-left: 429px;

    @media (max-width: 992px) {
        margin-bottom: 32px;
        margin-left: 0;
        text-align: center;
    }
`;

const Title = styled.h2`
    font-size: 37px;
    font-weight: 700;
    line-height: 1.2;
    color: #ffffff;
    margin: 0 0 24px 0;
    font-family: 'Unbounded';

    @media (max-width: 992px) {
        font-size: 28px;
        text-align: center;
        margin-bottom: 32px;
        br {
            display: none;
        }
    }
`;

const ContentBlock = styled.div`
    display: flex;
    gap: 26px;
    align-items: center;

    @media (max-width: 992px) {
        flex-direction: column;
    }
`;

const PhoneContainer = styled.div`
    flex: 1 1 0%;
    max-width: 404px;
    margin-top: -159px;
    position: relative;

    @media (max-width: 992px) {
        width: 100%;
        max-width: 404px;
        margin: 0 auto;
    }
`;

const PhoneImage = styled.img`
    height: auto;
    width: 234px;
    margin-top: 47px;
    margin-left: -12px;
    @media (max-width: 992px) {
        height: auto;
        width: 200px;
        margin-top: 47px;
        margin-left: 26px;
    }
`;
const MainPhoneImage = styled.img`
    height: auto;
    position: absolute;
    width: 243px;
    right: 0;
    @media (max-width: 992px) {
        height: auto;
        width: 200px;
        right: calc(60% - 183px);
        top: 14px;
    }
`;

const FeaturesContainer = styled.div`
    flex: 1;
`;

const FeaturesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 32px;
`;

const FeatureItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;
`;

const LightningIcon = styled.span`
    font-size: 24px;
    color: #ffffff;
    min-width: 24px;

    img {
        width: 46px;
    }
`;

const FeatureText = styled.p`
    font-size: 18px;
    line-height: 1.5;
    color: #ffffff;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const RequestButton = styled.button`
    background: #ffffff;
    color: #7c3aed;
    border: none;
    border-radius: 100px;
    padding: 16px 32px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 768px) {
        width: 100%;
        max-width: 280px;
        margin: 0 auto;
        display: block;
    }
`;

export default ContactsSection;
